
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiLayer as ObcPoiLayerElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-layer/poi-layer.js';
 
 
 

 
 export const ObcPoiLayer = createComponent({
   react: React,
   tagName: 'obc-poi-layer',
   elementClass: ObcPoiLayerElement,
   events: {
     
     onLayerResize: 'layer-resize' as EventName<CustomEvent<{height:number,label:string}>>,
   }
  });
 
 